const HREF_RE = /(\bhref\s*=\s*)(["'])(.*?)\2/gi;

export type HtmlHref = {
  match: string;
  prefix: string;
  quote: string;
  href: string;
};

export type HtmlHrefMatch = HtmlHref & {
  index: number;
};

const toHtmlHrefMatch = (match: RegExpExecArray): HtmlHrefMatch => ({
  match: match[0],
  prefix: match[1] ?? '',
  quote: match[2] ?? '',
  href: match[3] ?? '',
  index: match.index,
});

export const findHtmlHrefs = (html: string): HtmlHrefMatch[] =>
  Array.from(html.matchAll(HREF_RE), toHtmlHrefMatch);

export const replaceHtmlHrefs = (
  html: string,
  replaceHref: (href: HtmlHref) => string | null,
): string =>
  html.replace(
    HREF_RE,
    (match, prefix: string, quote: string, href: string) =>
      replaceHref({ match, prefix, quote, href }) ?? match,
  );
